// Import utilities
import {
	restCall
} from '@builder/common/utilities';

// Import utilities
const {
	isDefined
} = _uo.utility;

import {
	isAutomatorProActive
} from '@builder/utilities';

import { sanitizeConditionsForMeta } from '@builder/item/conditions/utilities';

import Actions from '@builder/item/actions';

/**
 * Updates the conditions saved in the recipe meta
 *
 * @param {Object}   options           The options
 * @param {Callback} options.onSuccess The callback invoked if the task is successful
 * @param {Callback} options.onFail    The callback invoked if the task is not successful
 * @return {undefined}
 */
const updateRemoteConditionsMeta = ( { onSuccess, onFail } ) => {
	// Update only if Pro is active
	if ( ! isAutomatorProActive() ) {
		return;
	}

	// Get conditions
	const conditions = sanitizeConditionsForMeta();

	// Do REST call
	restCall(
		// Endpoint
		'actions_conditions_update',

		// Data
		{
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator.recipe.id,
			// eslint-disable-next-line camelcase
			actions_conditions: JSON.stringify( conditions ),
		},

		// On success
		( response ) => {
			// Check if the task was successful
			if ( response.success ) {
				// Check if the onSuccess callback is defined
				if ( isDefined( onSuccess ) ) {
					try {
						// Clear the cache of tokens
						UncannyAutomator.cache.tokens = [];
						
						// Invoke onSuccess callback
						onSuccess( response );
					} catch ( e ) {
						if ( UncannyAutomator.dev.developerMode ) {
							// eslint-disable-next-line no-console
							console.error( "updateRemoteConditionsMeta: Couldn't execute the onSuccess callback." );

							// eslint-disable-next-line no-console
							console.error( e );
						}
					}
				}
			}
		},

		// On fail
		() => {
			if ( UncannyAutomator.dev.developerMode ) {
				// eslint-disable-next-line no-console
				console.error(
					"updateRemoteConditionsMeta: Couldn't update remote conditions meta. UI might be outdated."
				);
			}

			// Check if the onFail callback is defined
			if ( isDefined( onFail ) ) {
				try {
					// Invoke onFail callback
					onFail();
				} catch ( e ) {
					if ( UncannyAutomator.dev.developerMode ) {
						// eslint-disable-next-line no-console
						console.error( "updateRemoteConditionsMeta: Couldn't execute the onFail callback." );

						// eslint-disable-next-line no-console
						console.error( e );
					}
				}
			}
		}
	);
};

export default updateRemoteConditionsMeta;
